import { faces } from './categories/faces';
import { gestures } from './categories/gestures';
import { animals } from './categories/animals';
import { objects } from './categories/objects';
import { food } from './categories/food';
import { activities } from './categories/activities';
import { places } from './categories/places';
import { symbols } from './categories/symbols';
import { flags } from './categories/flags';
import { nature } from './categories/nature';
import { office } from './categories/office';
import { celebration } from './categories/celebration';
import { abstract } from './categories/abstract';
import { communication } from './categories/communication';
import { space } from './categories/space';
import { lifestyle } from './categories/lifestyle';
import { tech_future } from './categories/tech_future';
import { retro } from './categories/retro';
import { trends } from './categories/trends';
import { gaming_meta } from './categories/gaming_meta';
import { social_media } from './categories/social_media';
import { work_culture } from './categories/work_culture';
import { fashion_beauty } from './categories/fashion_beauty';
import { beauty_skincare } from './categories/beauty_skincare';
import { nightlife_beverages } from './categories/nightlife_beverages';
import { stationery_office } from './categories/stationery_office';
import { mahjong_culture } from './categories/mahjong_culture';
import { board_games } from './categories/board_games';
import { shopping_ecommerce } from './categories/shopping_ecommerce';
import { wellness_health } from './categories/wellness_health';
import { travel_vacation } from './categories/travel_vacation';
import { weather_seasons } from './categories/weather_seasons';
import { copywriting_bullets } from './categories/copywriting_bullets';
import { education_academic } from './categories/education_academic';
import { real_estate_living } from './categories/real_estate_living';
import { photography_visual } from './categories/photography_visual';
import { music_audio } from './categories/music_audio';
import { zodiac_mystic } from './categories/zodiac_mystic';
import { sports_fitness } from './categories/sports_fitness';
import { tech_ai } from './categories/tech_ai';
import { marketing_growth } from './categories/marketing_growth';
import { finance_crypto } from './categories/finance_crypto';
import { home_garden } from './categories/home_garden';
import { culture_festivals } from './categories/culture_festivals';
import { pet_care } from './categories/pet_care';
import { graphic_decoration } from './categories/graphic_decoration';
import { craft_diy } from './categories/craft_diy';
import { productivity_time } from './categories/productivity_time';
import { kitchen_cooking } from './categories/kitchen_cooking';
import { luxury_premium } from './categories/luxury_premium';
import { body_senses } from './categories/body_senses';
import { symbols_arrows } from './categories/symbols_arrows';
import { typography_deco } from './categories/typography_deco';
import { ecommerce_sales } from './categories/ecommerce_sales';
import { wellness_zen } from './categories/wellness_zen';
import { health_medical } from './categories/health_medical';
import { architecture_urban } from './categories/architecture_urban';

import * as FiIcons from 'react-icons/fi';

const createCategory = (items, categoryName) => {
  return items.map(e => Object.freeze({ ...e, category: categoryName }));
};

export const allEmojis = [
  ...createCategory(trends, 'trends'),
  ...createCategory(social_media, 'social_media'),
  ...createCategory(copywriting_bullets, 'copywriting_bullets'),
  ...createCategory(symbols_arrows, 'symbols_arrows'),
  ...createCategory(typography_deco, 'typography_deco'),
  ...createCategory(marketing_growth, 'marketing_growth'),
  ...createCategory(ecommerce_sales, 'ecommerce_sales'),
  ...createCategory(mahjong_culture, 'mahjong_culture'),
  ...createCategory(board_games, 'board_games'),
  ...createCategory(luxury_premium, 'luxury_premium'),
  ...createCategory(tech_future, 'tech_future'),
  ...createCategory(beauty_skincare, 'beauty_skincare'),
  ...createCategory(nightlife_beverages, 'nightlife_beverages'),
  ...createCategory(stationery_office, 'stationery_office'),
  ...createCategory(productivity_time, 'productivity_time'),
  ...createCategory(health_medical, 'health_medical'),
  ...createCategory(architecture_urban, 'architecture_urban'),
  ...createCategory(wellness_zen, 'wellness_zen'),
  ...createCategory(tech_ai, 'tech_ai'),
  ...createCategory(finance_crypto, 'finance_crypto'),
  ...createCategory(shopping_ecommerce, 'shopping_ecommerce'),
  ...createCategory(fashion_beauty, 'fashion_beauty'),
  ...createCategory(wellness_health, 'wellness_health'),
  ...createCategory(body_senses, 'body_senses'),
  ...createCategory(kitchen_cooking, 'kitchen_cooking'),
  ...createCategory(education_academic, 'education_academic'),
  ...createCategory(real_estate_living, 'real_estate_living'),
  ...createCategory(zodiac_mystic, 'zodiac_mystic'),
  ...createCategory(sports_fitness, 'sports_fitness'),
  ...createCategory(music_audio, 'music_audio'),
  ...createCategory(photography_visual, 'photography_visual'),
  ...createCategory(craft_diy, 'craft_diy'),
  ...createCategory(graphic_decoration, 'graphic_decoration'),
  ...createCategory(culture_festivals, 'culture_festivals'),
  ...createCategory(pet_care, 'pet_care'),
  ...createCategory(work_culture, 'work_culture'),
  ...createCategory(faces, 'faces'),
  ...createCategory(gestures, 'gestures'),
  ...createCategory(celebration, 'celebration'),
  ...createCategory(weather_seasons, 'weather_seasons'),
  ...createCategory(gaming_meta, 'gaming_meta'),
  ...createCategory(retro, 'retro'),
  ...createCategory(communication, 'communication'),
  ...createCategory(space, 'space'),
  ...createCategory(animals, 'animals'),
  ...createCategory(nature, 'nature'),
  ...createCategory(food, 'food'),
  ...createCategory(lifestyle, 'lifestyle'),
  ...createCategory(activities, 'activities'),
  ...createCategory(home_garden, 'home_garden'),
  ...createCategory(travel_vacation, 'travel_vacation'),
  ...createCategory(places, 'places'),
  ...createCategory(office, 'office'),
  ...createCategory(objects, 'objects'),
  ...createCategory(abstract, 'abstract'),
  ...createCategory(symbols, 'symbols'),
  ...createCategory(flags, 'flags'),
];

export const categories = [
  // --- Group: Discovery (趨勢與文案) ---
  { id: 'trends', name: '最新趨勢', icon: FiIcons.FiZap, group: 'discovery' },
  { id: 'social_media', name: '社群創作', icon: FiIcons.FiInstagram, group: 'discovery' },
  { id: 'copywriting_bullets', name: '文案排版', icon: FiIcons.FiList, group: 'discovery' },
  { id: 'symbols_arrows', name: '引導箭頭', icon: FiIcons.FiArrowRightCircle, group: 'discovery' },
  { id: 'graphic_decoration', name: '裝飾符號', icon: FiIcons.FiStar, group: 'discovery' },

  // --- Group: Business (專業行銷) ---
  { id: 'marketing_growth', name: '行銷增長', icon: FiIcons.FiTrendingUp, group: 'business' },
  { id: 'ecommerce_sales', name: '電商大促', icon: FiIcons.FiTag, group: 'business' },
  { id: 'tech_ai', name: '科技 AI', icon: FiIcons.FiCpu, group: 'business' },
  { id: 'finance_crypto', name: '金融加密', icon: FiIcons.FiDollarSign, group: 'business' },
  { id: 'architecture_urban', name: '建築城市', icon: FiIcons.FiMap, group: 'business' },
  { id: 'health_medical', name: '醫療健康', icon: FiIcons.FiActivity, group: 'business' },

  // --- Group: Lifestyle (生活文化) ---
  { id: 'mahjong_culture', name: '雀神靈感', icon: FiIcons.FiTarget, group: 'lifestyle' },
  { id: 'luxury_premium', name: '奢華質感', icon: FiIcons.FiAward, group: 'lifestyle' },
  { id: 'beauty_skincare', name: '美妝護膚', icon: FiIcons.FiDroplet, group: 'lifestyle' },
  { id: 'food', name: '美食飲品', icon: FiIcons.FiCoffee, group: 'lifestyle' },
  { id: 'travel_vacation', name: '旅遊度假', icon: FiIcons.FiMapPin, group: 'lifestyle' },
  { id: 'wellness_zen', name: '療癒禪意', icon: FiIcons.FiWind, group: 'lifestyle' },
  { id: 'zodiac_mystic', name: '星座神秘', icon: FiIcons.FiMoon, group: 'lifestyle' },

  // --- Group: Basic Elements (基礎萬用) ---
  { id: 'faces', name: '情感表情', icon: FiIcons.FiSmile, group: 'elements' },
  { id: 'gestures', name: '人物動作', icon: FiIcons.FiUser, group: 'elements' },
  { id: 'animals', name: '動物生物', icon: FiIcons.FiGithub, group: 'elements' },
  { id: 'nature', name: '自然天氣', icon: FiIcons.FiSun, group: 'elements' },
  { id: 'objects', name: '生活物品', icon: FiIcons.FiBox, group: 'elements' },
  { id: 'symbols', name: '符號標誌', icon: FiIcons.FiHash, group: 'elements' },
  { id: 'flags', name: '國界世界', icon: FiIcons.FiFlag, group: 'elements' },
];